const NED_CONE_SEARCH_URL = 'https://ned.ipac.caltech.edu/conesearch'
const NED_COORDINATE_DECIMAL_PLACES = 12

function formatNedDegrees(value: number) {
  const formatted = value.toFixed(NED_COORDINATE_DECIMAL_PLACES).replace(/\.?0+$/, '')
  return formatted === '-0' ? '0' : formatted
}

export function nedConeSearchUrl(raDeg: number, decDeg: number, radiusArcmin: number) {
  const params = new URLSearchParams()
  params.set('search_type', 'Near Position Search')
  params.set('in_csys', 'Equatorial')
  params.set('in_equinox', 'J2000')
  params.set('ra', `${formatNedDegrees(raDeg)}d`)
  params.set('dec', `${formatNedDegrees(decDeg)}d`)
  params.set('radius', String(radiusArcmin))
  return `${NED_CONE_SEARCH_URL}?${params.toString()}`
}
